// 维保拜访计划
import {dynamicPropsFn} from './util.js'
const WbVisitPlanList = resolve =>
  require(['@/views/WbVisitPlan/List'], resolve)
const WbVisitPlanDetail = resolve =>
  require(['@/views/WbVisitPlan/Detail'], resolve)
const WbVisitPlanNew = resolve =>
  require(['@/views/WbVisitPlan/New'], resolve)
const WbVisitPlanEdit = resolve =>
  require(['@/views/WbVisitPlan/Edit'], resolve)
export default [
  {
    name: 'WbVisitPlan_list',
    path: '/wbVisitPlan/list',
    component: WbVisitPlanList,
    meta: {
      keepAlive: false,
      title: '拜访计划列表',
    },
  },
  {
    name: 'WbVisitPlan_detail',
    path: '/wbVisitPlan/list/detail',
    component: WbVisitPlanDetail,
    meta: {
      keepAlive: false,
      title: '拜访计划详情',
    },
  },
  {
    name: 'WbVisitPlan_new',
    path: '/wbVisitPlan/list/new',
    component: WbVisitPlanNew,
    meta: {
      keepAlive: false,
      title: '新建拜访计划',
    },
  },
  {
    name: 'WbVisitPlan_edit',
    path: '/wbVisitPlan/list/detail/edit',
    component: WbVisitPlanEdit,
    props: dynamicPropsFn,
    meta: {
      keepAlive: false,
      title: '编辑拜访计划',
    },
  },
]



// WEBPACK FOOTER //
// ./src/router/wbVisitPlan.js